/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Card, Grid, LinearProgress } from '@mui/material';
import { CardList, DialogForm, ICardActions, ICardColumns, IChipFilter, IDialogActions, IKanbanCardColumns, ISnackbarAlert, ISwitchInputProps, KanbanList, SelectField, SnackbarAlert, TextFieldInput, ToolBar } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { useTheme } from '@mui/material/styles';
import { AccessRoleDTO, AccessRoleFilterDTO, UserGroupUserDTO, UserGroupUserFilterDTO, ValueListDTO } from '../../../shared/interfaces';
import { LayoutDashboard } from '../../../shared/layouts';
import { useTranslation } from 'react-i18next';

interface IUserGroupUserAssociateProps {
    data: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
    actionExecuted: boolean | false;
}

export const UserGroupUserAssociate: React.FC<IUserGroupUserAssociateProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted, actionExecuted }) => {
    const [userGroupUserDTO, setUserGroupUserDTO] = useState<UserGroupUserDTO>();
    const [userGroupUserFilterSelectedDTO, setUserGroupUserFilterSelectedDTO] = useState<UserGroupUserFilterDTO>();
    const [userGroupUserFilterAvailableDTO, setUserGroupUserFilterAvailableDTO] = useState<UserGroupUserFilterDTO>();
    const [userGroupListSelected, setUserGroupListSelected] = useState<UserGroupUserDTO[]>([]);
    const [userGroupListAvailable, setUserGroupListAvailable] = useState<UserGroupUserDTO[]>([]);

    const [deleteRecord, setDeleteRecord] = useState('');
    const [userGroupSelect, setUserGroupSelect] = useState(false);

    const [loading, setLoading] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenSnackBar] = useState(false);

    const theme = useTheme();

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    useEffect(() => {
        setUserGroupUserFilterSelectedDTO({
            ...userGroupUserFilterSelectedDTO,
            name: '',
            userGroupId: '',
            userId: data.id,
            createdById: '',
            searchAssociated: true
        } as UserGroupUserFilterDTO);

        setUserGroupUserFilterAvailableDTO({
            ...userGroupUserFilterAvailableDTO,
            name: '',
            userGroupId: '',
            userId: data.id,
            searchAssociated: false
        } as UserGroupUserFilterDTO);

        setUserGroupUserDTO({
            ...userGroupUserDTO,
            name: '',
            userGroupId: '',
            userId: '',
            createdById: ''
        } as UserGroupUserDTO);

        handleGetPermission(ListId.authsphere.userGroupUserId, setAccessRolePermissionDTO);

    }, [data]);

    useEffect(() => {
        handleGetPermission(ListId.authsphere.userGroupUserId, setAccessRolePermissionDTO);
    }, [data]);

    useEffect(() => {
        if(accessRolePermissionDTO?.allowGetAllView == undefined)
            return;
        if(!accessRolePermissionDTO?.allowGetAllView) {
            showMessage(t('userGroup.userAssociate.message.accessRolePermissionDTO'), 'info');
            return;
        }
        handleUserGroupGetAllViewAsync(setUserGroupListSelected, userGroupUserFilterSelectedDTO);
        handleUserGroupGetAllViewAsync(setUserGroupListAvailable, userGroupUserFilterAvailableDTO);
    }, [userGroupUserFilterSelectedDTO, userGroupUserFilterAvailableDTO]);

    useEffect(() => {
        if(accessRolePermissionDTO?.allowGetAllView == undefined)
            return;
        if(!accessRolePermissionDTO?.allowGetAllView) {
            showMessage(t('userGroup.userAssociate.message.accessRolePermissionDTO'), 'info');
            return;
        }
        if (actionExecuted) {
            handleUserGroupGetAllViewAsync(setUserGroupListSelected, userGroupUserFilterSelectedDTO);
            handleUserGroupGetAllViewAsync(setUserGroupListAvailable, userGroupUserFilterAvailableDTO);
        }
    }, [actionExecuted]);

    const handleGetPermission = useCallback(async (featureId: string, setList: any) => {
        const accessRoleFilterDTO: AccessRoleFilterDTO = {
            featureId: featureId,
            userId: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('authsphere.AccessRole', 'GetPermissionAsync', accessRoleFilterDTO, setActionExecuted, setLoading, undefined, setList,);
    }, []);

    const handleUserGroupGetAllViewAsync = useCallback(async (setList: any, filterDTO?: UserGroupUserFilterDTO,) => {
        if (filterDTO === undefined)
            return;

        GenericService.GetAllViewAsync1('authsphere.UserGroupUser', filterDTO, setActionExecuted, setLoading, setList, showMessage, true);
    }, [data]);

    const HandleUserGroupAddAsync = useCallback(async (userGroupUser: any) => {
        const dto: UserGroupUserDTO = {
            userGroupId: userGroupUser.id,
            userId: data.id,
            createdById: userInfo.user.id
        };
        GenericService.AddAsync1('authsphere.UserGroupUser', dto, setUserGroupUserDTO, setActionExecuted, setLoading, showMessage);
    }, [data]);

    const handleDeleteClick = useCallback(async (userGroupUser: any) => {
        const dto: UserGroupUserDTO = {
            userGroupId: userGroupUser.id,
            userId: data.id,
            createdById: userInfo.user.id
        };
        GenericService.PostGenericAsync1('authsphere.UserGroupUser', 'DeleteByAsync', dto, setActionExecuted, setLoading, showMessage);
    }, [data]);

    const handleAssociateClick = (userGroupUser: string) => {
        if(!accessRolePermissionDTO?.allowAdd) {
            showMessage(t('userGroup.userAssociate.message.handleAssociateClick'), 'info');
            return;
        }
        HandleUserGroupAddAsync(userGroupUser);
    };

    const handleDisassociate = (userGroupUser: string) => {
        if(!accessRolePermissionDTO?.allowDelete) {
            showMessage(t('message.allowDelete'), 'info');
            return;
        }
        handleDeleteClick(userGroupUser);
    };

    const handleClearFilterSelectedClick = () => {
        setUserGroupUserFilterSelectedDTO({
            ...userGroupUserFilterSelectedDTO,
            name: '',
            userGroupId: '',
            userId: data.id,
            createdById: '',
            searchAssociated: true
        } as UserGroupUserFilterDTO);
    };

    const handleSearchSelectedClick = () => {
        handleUserGroupGetAllViewAsync(setUserGroupListSelected, userGroupUserFilterSelectedDTO);
    };

    const handleClearFilterAvailableClick = () => {
        setUserGroupUserFilterSelectedDTO({
            ...userGroupUserFilterSelectedDTO,
            name: '',
            userGroupId: '',
            userId: data.id,
            createdById: '',
            statusId: '',
            searchAssociated: true
        } as UserGroupUserFilterDTO);
    };

    const handleSearchAvailableClick = () => {
        handleUserGroupGetAllViewAsync(setUserGroupListSelected, userGroupUserFilterSelectedDTO);
    };

    const userGroupSelectText = userGroupSelect ? t('userGroup.userAssociate.userGroupSelectText.userGroupSelectClose') : t('userGroup.userAssociate.userGroupSelectText.userGroupSelect');

    const actions: IDialogActions[] = [
        { id: 'close', text: t('userGroup.userAssociate.actions.close'), icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    //selected
    const columnsSelected: ICardColumns[] = [
        { field: 'name', label: t('userGroup.userAssociate.columnsSelected.userName'), size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
    ];

    const cardActionsSelected: ICardActions[] = [
        { id: 'disassociate', toolTip: t('userGroup.userAssociate.cardActionsSelected.disassociate'), icon: 'delete_outlined', iconColor: 'error', setAction: handleDisassociate },
    ];

    const chipFiltersSelected: IChipFilter[] = [
        { label: t('userGroup.userAssociate.chipFiltersSelected.totalRecords'), value: userGroupListSelected.length },
        { label: t('userGroup.userAssociate.chipFiltersSelected.userName'), value: userGroupUserFilterSelectedDTO?.name },
    ];

    const toolBarActionsSelected: IDialogActions[] = [
    ];

    //available
    const columnsAvailable: ICardColumns[] = [
        { field: 'name', label: t('userGroup.userAssociate.chipFiltersSelected.fullName'), size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
    ];

    const cardActionsAvailable: ICardActions[] = [
        { id: 'associate', toolTip: t('userGroup.userAssociate.cardActionsAvailable.associate'), icon: 'add_circle_outlined', iconColor: 'primary', setAction: handleAssociateClick },
    ];

    const chipFiltersAvailable: IChipFilter[] = [
        { label: t('userGroup.userAssociate.chipFiltersAvailable.totalRecords'), value: userGroupListSelected.length },
        { label: t('userGroup.userAssociate.chipFiltersAvailable.userName'), value: userGroupUserFilterSelectedDTO?.name },
    ];

    const toolBarActionsAvailable: IDialogActions[] = [
    ];

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarMessage(msg);
        setIsOpenSnackBar(true);
    }
    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarMessage}
                    setIsOpen={setIsOpenSnackBar}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title={`${t('userGroup.userAssociate.dialogForm.title')} - ${data.companyId} - ${data.name}`}
                icon='compare_arrows_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'xl'}
                actions={actions}
                loading={false}
            >
                <LayoutDashboard title={t('userGroup.userAssociate.layoutDashboard.title')}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Card sx={{ bgcolor: theme.palette.background.default, p: 1, height: '58vh' }}>
                                <ToolBar
                                    clickSearch={handleSearchSelectedClick}
                                    clickClearFilter={handleClearFilterSelectedClick}
                                    chipFilters={chipFiltersSelected}
                                    actions={toolBarActionsSelected}
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='name'
                                                label={t('userGroup.userAssociate.textFieldInput.label.name')}
                                                setValue={setUserGroupUserFilterSelectedDTO}
                                                value={userGroupUserFilterSelectedDTO?.name}
                                                obj={userGroupUserFilterSelectedDTO}
                                                placeholder={t('userGroup.userAssociate.textFieldInput.label.name')}
                                                maxLength={200}
                                            />
                                        </Grid>
                                    </Grid>
                                </ToolBar>
                                {loading && (
                                    <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                                )}
                                <Box sx={{ display: 'flex', maxHeight: '50vh', width: '100%', overflow: 'hidden', overflowY: 'auto' }}>
                                    <CardList
                                        columns={columnsSelected}
                                        rows={userGroupListSelected}
                                        actions={cardActionsSelected}
                                        hasChildren={false}
                                        setRowExpanded={() => void undefined}
                                        cardSize={12}
                                    />
                                </Box>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Card sx={{ bgcolor: theme.palette.background.default, p: 1, height: '58vh' }}>
                                <ToolBar
                                    clickSearch={handleSearchAvailableClick}
                                    clickClearFilter={handleClearFilterAvailableClick}
                                    chipFilters={chipFiltersAvailable}
                                    actions={toolBarActionsAvailable}
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='name'
                                                label={t('userGroup.userAssociate.textFieldInput.label.name')}
                                                setValue={setUserGroupUserFilterAvailableDTO}
                                                value={userGroupUserFilterAvailableDTO?.name}
                                                obj={userGroupUserFilterAvailableDTO}
                                                placeholder={t('userGroup.userAssociate.textFieldInput.label.name')}
                                                maxLength={200}
                                            />
                                        </Grid>
                                    </Grid>
                                </ToolBar>
                                {loading && (
                                    <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                                )}
                                <Box sx={{ display: 'flex', maxHeight: '50vh', width: '100%', overflow: 'hidden', overflowY: 'auto' }}>
                                    <CardList
                                        columns={columnsAvailable}
                                        rows={userGroupListAvailable}
                                        actions={cardActionsAvailable}
                                        hasChildren={false}
                                        setRowExpanded={() => void undefined}
                                        cardSize={12}
                                    />
                                </Box>
                            </Card>
                        </Grid>
                    </Grid>
                </LayoutDashboard>
            </DialogForm >
        </React.Fragment >
    );
};
